import React, { useEffect, useState } from 'react'
import { CHART_COLORS, CHART_OPTIONS } from '../../../constant/ApplicationVariables';
import { Box, useTheme } from '@mui/material';
import { Bar } from 'react-chartjs-2';

export default function GraphComponent({ title, data, props }) {
    const theme = useTheme();

    const [chartDataList, setChartDataList] = useState(null);

    const options = {
        ...CHART_OPTIONS,


        plugins: {
            ...CHART_OPTIONS.plugins,
            title: {
                ...CHART_OPTIONS.plugins.title,
                // text: title,
                // display: property?.label,
                display: false,

            },
            datalabels: {
                ...CHART_OPTIONS.plugins.datalabels,
                display : false,
            }
            // legend: {
            //     position: 'top',
            // },
            // title: {
            //     display: false,
            //     text: "User Story",
            // },

        },
    };


    const outputData = {
        labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
        datasets: [
            {
                label: "HIGH",
                data: [20, 20, 20, 20, 20],
                backgroundColor: theme.palette.secondary.main,
            },
            {
                label: "MEDIUM",
                data: [30, 30, 30, 30, 30],
                backgroundColor: theme.palette.secondary.main,
            },
            {
                label: "LOW",
                data: [60, 60, 60, 60, 60],
                backgroundColor: theme.palette.secondary.main,
            },
        ],
    };


    function transformData1(inputList) {
        const labels = inputList?.map(item => item.name);
        const datasets = inputList[0].properties?.map(prop => ({
            label: prop.name,
            data: inputList?.map(item => item.properties?.find(p => p.name === prop.name).value),
            backgroundColor: theme.palette.secondary.main,
        }));

        return { labels, datasets };
    }


    

    function transformData5(inputList) {
        const labels = inputList?.map(item => item.name);
        const datasets = Array.from(new Set(inputList?.flatMap(item => item.properties?.map(prop => prop.name))))?.map((name, index) => ({
            label: name,
            data: inputList?.map(item => item.properties?.find(prop => prop.name === name)?.value),
            // backgroundColor: COLORS[index % COLORS.length]
            backgroundColor: CHART_COLORS[index][400],
        }));

        return { labels, datasets };
    }

    function transformData(labelList, datasetList, colorList) {
        const labels = labelList?.map(item => item);
        const datasets = datasetList?.map((dataSet, index) => ({
            label: dataSet?.label,
            data: dataSet?.data,
            backgroundColor: colorList ? colorList[index] : CHART_COLORS[index][400],
            borderColor: colorList ? colorList[index] : CHART_COLORS[index][700],
            borderWidth: 1,
        }));

        return { labels, datasets };
    }

    // console.log("datasets", transformData5(list))



    // useEffect(() => {
    //     if (list?.length > 0) {
    //         setChartDataList(transformData5(list));
    //     }
    // }, [list]);

    useEffect(() => {
        if (data) {
            setChartDataList(transformData(data?.labels, data?.datasets, data?.colorsList));
        }
    }, [data]);


    /*
    {
    "labels": [
        "Folder1",
        "Folder2",
        "Folder3",
        "Folder4",
        "Folder5"
    ],
    "datasets": [
        {
            "label": "HIGH",
            "data": [
                20,
                20,
                20,
                20,
                20
            ],
            "backgroundColor": "#1A73E8"
        },
        {
            "label": "MEDIUM",
            "data": [
                30,
                30,
                30,
                30,
                30
            ],
            "backgroundColor": "#1A73E8"
        },
        {
            "label": "LOW",
            "data": [
                60,
                60,
                60,
                60,
                60
            ],
            "backgroundColor": "#1A73E8"
        }
    ]
}
    */


    console.log(chartDataList, "chartDataList")

    return (
        <Box className="flex items-center justify-center px-4 py-4 w-full h-full ">
            {chartDataList && <Bar options={options} data={chartDataList} redraw={false} width={props?.width ? props?.width : "auto"} height={props?.height ? props?.height : "100%"} />}
        </Box>
    )
}